import { Injectable } from '@angular/core';
import { AppealSearchApiModel } from '../../models/appeal-judgement/appeal-judgement';
import { AppealSearchModel } from '../../view-models/appeal-judgement';
import { inputSearchModel } from '../../view-models/testify';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class InputSearchAppealMapper implements Mapper<AppealSearchApiModel, AppealSearchModel>  {
    constructor(

    ) { }
    mapForm(param: AppealSearchApiModel): AppealSearchModel {
        return null!
    }

    mapTo(param: AppealSearchModel): AppealSearchApiModel {
        let secId:number = 0
        if(!param.administrativeCourt){
            param.administrativeCourt = 0
        }
        if(param.blackNumberCase){
            secId = param.blackNumberCase
        }else if(param.redNumberCase){
            secId = param.redNumberCase
        }else{
            secId = 0 
        }
        return {
            cId:param.administrativeCourt,
            secId:secId,
            suitBlackNo:param.suitBlackCode,
            suitBlackYear:param.suitBlackYear,
            suitRedNo:param.suitRedCode,
            suitRedYear:param.suitRedYear,
            suitTypeId:param.suitTypeId,
            fdtId:param.fdtId,
            suitId:param.suitId,
            refCode:param.refCode,
            isRefCode:param.isRefCode
        }
    }

} 